


























































































import { Component, Prop, Model, Vue } from "vue-property-decorator";
import { GapLabTest } from "@/store/modules/types";
import ModalHeader from "@/components/ModalHeader.vue";
import { VueEditor } from "vue2-editor";
import DatePicker from "vuejs-datepicker";

@Component({
  components: {
    ModalHeader,
    VueEditor,
    DatePicker,
  },
})
export default class GapLabTestEditor extends Vue {
  @Prop(Number) readonly gapId!: number;
  @Model("change") readonly test!: GapLabTest;
  testTypes = Array<any>();
  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
    ],
  };
  async saveLab() {
    if (!this.test.typeId || !this.test.name || !this.test.date) return;
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { gapId, test } = this;
      await this.$store.dispatch("gaps/saveLabTest", { gapId, test });
      this.$modal.hide("gap-lab-test");
      this.$emit("test-saved");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getTestTypes() {
    try {
      this.testTypes = await this.$store.dispatch("gaps/getLabTestTypes");
    } catch (error) {
      console.log(error);
    }
  }
  mounted() {
    this.getTestTypes();
  }
}
